import React from 'react';
import EditorAssistFloatingDock from 'components/rich-text/EditorAssistFloatingDock';
import NeoAiTemplateChatPanel from './NeoAiTemplateChatPanel';

const TemplateEditorFloatingDock = ({ onNeoCoinBalanceUpdate }) => (
  <EditorAssistFloatingDock
    neoAiPanel={
      <NeoAiTemplateChatPanel onNeoCoinBalanceUpdate={onNeoCoinBalanceUpdate} />
    }
  />
);

export default TemplateEditorFloatingDock;
